<template>
  <div>
    <slide-viewer />
    <div class="fullwidth spaceover">
      <style-browse-panel v-on:click="selectGallery" :gallery="gallery"  />
    </div>
    <div class="fullwidth">
      
      <div class="style-grid">
        <div class="gallery-area">
          <h3>{{ gallery.name }} {{ $nippets.illustrators.toLowerCase() }}</h3>
          <style-area :gallery="gallery" />
          <div class="b-panel">
            <ix-router-link class="bigbutton" :to="gallery.url" v-if="galStyleLink">{{ galStyleLink }}</ix-router-link>
          </div>
        </div>
        <div class="news-area" v-if="(mwidth > 767) && (!isChina)">
          <h3>{{ gallery.name }} {{ $nippets.news.toLowerCase() }}</h3>
          <news-area :tag="tag" />
          <div class="b-panel">
            <ix-router-link class="bigbutton" :to="'/news/tags/' + tag" v-if="galNewsLink">{{ galNewsLink }}</ix-router-link>
          </div>
        </div>
        <div class="news-area" v-if="(mwidth > 767) && (isChina)">
          <h3>&nbsp;</h3>
          <china-styles :gallery="gallery" />
        </div>
      </div>
    </div>
    <seen-panel v-if="!$store.getters.isNonEnglish">
      <testimonials-panel  />
    </seen-panel>
    <template v-if="mwidth > 767">
      <div class="fullwidth">
        <home-trees />
      </div>
      <div class="fullwidth darker">
        <team-panel />
      </div>
      <div class="fullwidth">
        <animationx-ad />
      </div>
    </template>
    <div class="fullwidth" :class="{darker: mwidth > 767}">
      <style-browser />
    </div>
    <home-page-dialog />
  </div>
</template>

<script>
import HomePageDialog from '@/components/dialogs/HomePageDialog.vue'
import SlideViewer from './home/SlideViewer.vue'
import TestimonialsPanel from '@/components/panels/TestimonialPanel.vue'
import StyleArea from './home/StyleArea.vue'
import stg from '@/data/home-style-galleries.js'
import NewsArea from './home/NewsArea.vue'
import StyleBrowser from '@/components/panels/StyleBrowser.vue'
import HomeTrees from './home/HomeTrees.vue'
import TeamPanel from './home/TeamPanel.vue'
import AnimationxAd from './home/AnimationxAd.vue'
import StyleBrowsePanel from './home/StyleBrowsePanel.vue'
import MetatagPage from '@/mixins/MetatagPage.js'
import SeenPanel from '@/components/panels/SeenPanel.vue'

export default {
  mixins: [MetatagPage],
  components: {
    SlideViewer,
    TestimonialsPanel,
    StyleArea,
    NewsArea,
    StyleBrowser,
    HomeTrees,
    TeamPanel,
    AnimationxAd,
    StyleBrowsePanel,
    SeenPanel,
    HomePageDialog,
    ChinaStyles: () => import(/* webpackChunkName: "china" */ '@/views/illustration/home/ChinaExtraStyles.vue'),
  },
  data () {
    return {
      gallery: {},
      tag: null,
      galStyleLink: null,
      galNewsLink: null,
      mwidth:1024
    }
  },
  computed: {
    isChina () {
      return this.$store.state.lang === 'CN'
    }
  },
  created () {
    this.chooseGallery()
  },
  mounted () {
    this.checkSize()
    window.addEventListener('resize', this.checkSize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkSize)
  },
  methods: {
    checkSize() {
      this.mwidth = window.innerWidth
    },
    selectGallery(gallery) {
      this.gallery = gallery
      this.tag = gallery.url.split('/').pop()
      this.galStyleLink = this.$nippets.replace('home.moreStyle', 'gallery', this.gallery.name.toLowerCase())
      this.galNewsLink = this.$nippets.replace('home.moreNews', 'gallery', this.gallery.name.toLowerCase())
      this.$store.commit('setDefaultGallery', gallery.url)
    },
    async chooseGallery () {
      let galname = stg.getRandomGallery()
      if(this.$store.state.defaultGallery) {
        galname = this.$store.state.defaultGallery
      }
      this.gallery = await this.$store.dispatch('fetchGallery', galname)
      this.tag = galname.split('/').pop()
      this.galStyleLink = this.$nippets.replace('home.moreStyle', 'gallery', this.gallery.name.toLowerCase())
      this.galNewsLink = this.$nippets.replace('home.moreNews', 'gallery', this.gallery.name.toLowerCase())
    }
  }
}
</script>
<style>
  .b-panel{
    padding:15px 0;
  }

  
</style>
<style scoped>
  h3{
    color:#101820;
    font-size:33px;
    margin-top:0;
  }
  
  .style-grid{
    display:grid;
    grid-template-columns: calc(66.66% - 10px) calc(33.33% - 10px);
    grid-gap:20px;
  }

  .news-area{
    display:flex;
    flex-direction:column;
  }
  

  @media screen and (max-width:767px){
    h3{
      font-size:24px;
    }
    .style-grid{
      display:block;
    }
  }


  
</style>

